define('angular-lightslider',["lightgallery"], function() {
    var app = angular.module('angular.lightslider', []);
    app.directive('lightslider', [function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

                // console.log(typeof attrs.typeConfig)

                attrs.typeConfig = (typeof attrs.typeConfig != 'undefined') ? attrs.typeConfig : 'slider';

                if(attrs.typeConfig == 'slider'){

                    var configOp = {
                        gallery: true,
                        auto : true,
                        item :1,
                        loop :true,
                        pause : attrs.pauseTime,
                        speed : 600,
                        thumbItem :9,
                        slideMargin :0,
                        enableDrag : false,
                        pauseOnHover : true,
                        pagination: ".pagination",
                        currentPagerPosition :'left',
                        onSliderLoad: function(el) {
                            el.lightGallery({
                                selector  : '.buildingGallery .lslide',
                                thumbnail :true,
                                animateThumb  : true,
                                showThumbByDefault  : true
                            });
                        }
                    }
                }

                else if(attrs.typeConfig == 'carousel'){
                    var configOp = {
                        item:4,
                        auto : true,
                        loop:true,
                        slideMove:2,
                        easing: 'linear',
                        speed:1000,
                        pauseOnHover: true,
                        pause : 5000,
                        responsive : [
                            {
                                breakpoint:1400,
                                settings: {
                                    item:3,
                                    slideMove:1,
                                }
                            },
                            {
                                breakpoint:480,
                                settings: {
                                    item:2,
                                    slideMove:1
                                }
                            }
                        ],
                        onSliderLoad: function(el) {
                            el.lightGallery({
                                selector  : '.buildingGallery .lslide',
                                thumbnail :true,
                                animateThumb  : true,
                                showThumbByDefault  : true
                            });
                        }
                    }
                }





                //console.log(configOp);

                if(typeof attrs.noGallery !== 'undefined'){
                    delete configOp.gallery;

                }


                var config = angular.extend(configOp, scope.$eval(attrs.cycle));

              //  console.log(config);

                setTimeout(function () {
                    element.lightSlider(config);
                }, 500);
            }
        };
    }]).directive('lightgallery', [function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var config = angular.extend({}, scope.$eval(attrs.cycle));
                element.lightGallery(config);
                element.on('click', function(){
                    element.lightGallery(config);
                })
            }
        };
    }]).directive('caroufredsel', [function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var config = angular.extend({
                    direction : "left",
                    pagination: {
                        container: function(){
                            return $(this).parent().parent().parent().find(".pager");
                        }
                    },
                    prev: {
                        button: function() {
                            return $(this).parent().parent().parent().find(".prev");
                        }
                    },
                    next: {
                        button: function() {
                            return $(this).parent().parent().parent().find(".next");
                        }
                    },
                    width     : attrs.caroufredselWidth,
                    height    : attrs.caroufredselHeight,
                    responsive: "true",
                    items     : {
                        width: 360,
                        visible: {
                              min: 1,
                              max: parseInt(attrs.caroufredselTotal)
                          }
                      },
                    scroll : {
                        items   : parseInt(attrs.caroufredselItem),
                        fx      : attrs.caroufredselFx,
                        pauseOnHover: true,
                        duration : 800
                    }
                }, scope.$eval(attrs.cycle));
                setTimeout(function () {
                    // element.carouFredSel('destroy');
                    element.carouFredSel(config);
                }, 0);
            }
        };

    }]).directive('caroufredsel2', [function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var config = angular.extend({
                    direction : "left",
                    pagination: {
                        container: function(){
                            return $(this).parent().siblings(".pager");
                        }
                    },
                    prev: {
                        button: function() {
                            return $(this).parent().siblings(".prev");
                        }
                    },
                    next: {
                        button: function() {
                            return $(this).parent().siblings(".next");
                        }
                    },
                    width     : attrs.caroufredselWidth,
                    height    : attrs.caroufredselHeight,
                    responsive: "true",
                    items     : {
                        width: 250,
                        visible: {
                            min: 1,
                            max: parseInt(attrs.caroufredselTotal)
                        }
                    },
                    scroll    : {
                        items   : parseInt(attrs.caroufredselItem),
                        fx      : attrs.caroufredselFx,
                        pauseOnHover: true,
                        duration : 800
                    }
                }, scope.$eval(attrs.cycle));
                setTimeout(function () {
                    // element.carouFredSel('destroy');
                    element.carouFredSel(config);
                }, 0);
            }
        };

    }]).directive('caroufredselMenuShow', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var config =
                   {
                        direction : "left",
                        auto: true,
                        prev: {
                            button: function() {
                                return $("#menu-carousel, #menu-desktop__carousel").parent().parent().siblings(".prev");               }
                        },
                        next: {
                            button: function() {
                                return $("#menu-carousel, #menu-desktop__carousel").parent().parent().siblings(".next");
                            }
                        },
                        width     : $("#menu-carousel, #menu-desktop__carousel").width(),
                        height    : $("#menu-carousel, #menu-desktop__carousel").height(),
                        responsive: "true",
                        items     : {
                            visible: {
                                min: 1,
                                max: 4
                            }
                        },
                        scroll    : {
                            pauseOnHover: true,
                            items   : 1,
                            fx      : 'scroll',
                            duration : 800
                        }
                    };
              //  console.log($timeout)
                setTimeout(function () {
                //    $("#menu-carousel, #menu-desktop__carousel").carouFredSel('destroy');
                    $("#menu-carousel, #menu-desktop__carousel").carouFredSel(config);
                }, 0);
            }
        };
    }])
});
